// $(document).ready(function(){
  
//     /*Wishlist Trigger click*/
//         $(".wishlist-ctm-button").click(function(){
//            $(this).toggleClass('added');
//            $(".check-wish").find(".wishlist-engine").trigger('click');
//         });
//          $(window).on('load', function () {
//               $(".wishlist-engine").each(function(){
//                   var compr_wish = $(this).attr('data-added');
//                   if(compr_wish == 'true'){
//                    $(".wishlist-ctm-button").toggleClass('added');
//                   }
//               });
//          });
//    /*End Wishlist Trigger click*/     

//    /*JS FOR CUSTOM POPU IN HOME PAGE START*/
//    // $('.wrapper_popup, .overlay_popup').fadeIn("slow");
//    //          $('.template-index').css("overflow","hidden");
//    //          $('.cancle_icon svg, .overlay_popup').click(function(){
//    //            $('.wrapper_popup, .overlay_popup').fadeOut("slow");
//    //               $('.template-index').css("overflow","visible");
//    //          });
//    //            $('.wrapper_popup').find('label.form-field-title').text('Enter your email');
//           /*JS FOR CUSTOM POPU IN HOME PAGE NED*/

//         /*JS FOR HIDE/SHOW PRODUCT THUMBNAIL START*/
//             $("button.slick-arrow").click(function(){
//                 $("button.slick-arrow").removeClass('hide-display');
//                   $(this).addClass('hide-display');
//               $('.pswp').hide();
//             });
//             $(".product-gallery--viewer.slider-for .slick-list.draggable").click(function(){
//               $('.pswp').show();
//               $('.product-zoom--thumb-scroller').hide();
//             });
//         /*JS HIDE/SHOW PRODUCT THUMBNAIL END*/
        
//         /*JS FRO FILTER DRAWER START*/
//              $('.filter_access').click(function(){
//           $('.productgrid--sidebar').css("transform","translate(0)");
//         });
//          $('.close-icon-svg svg').click(function(){
//             $('.productgrid--sidebar').css("transform","translate(-300px)");
//          });
//         /*JS FOR FILTER DRAWER END*/

//         /*JS FOR WISHLIST START*/
//           $(document).find(".wishlist-engine").click(function(){
//               var ths_attr = $(this).attr('data-added');
//               if(ths_attr == 'true'){
//                 $(this).closest('.itg_collection_wishlist').find('.itg_hover_content').html("Add to Wishlist");
//               }else{
//                  $(this).closest('.itg_collection_wishlist').find('.itg_hover_content').html("Remove from Wishlist");
//               }
//           });

//           $(document).on('click', '.wishlist-page .wishlist-move-cart', function(){
//               setTimeout(function () {
//                   $.getJSON('/cart', function(cart){
//                     console.log(cart)
//                       $('.site-header-cart--count').attr('data-header-cart-count', cart.item_count)
//                   })
//               }, 500)
//           })
          
//           $(window).on('load', function () {
//               $(".wishlist-engine").each(function(){
//                   var ths_attr = $(this).attr('data-added');
//                   if(ths_attr == 'true'){
//                     $(this).closest('.itg_collection_wishlist').find('.itg_hover_content').html("Remove from Wishlist");
//                   }else{
//                      $(this).closest('.itg_collection_wishlist').find('.itg_hover_content').html("Add to Wishlist");
//                   }
//               });
//           });
//         /*JS FOR WISHLIST END*/
//             $(document).on('click', '.itg_popup_click', function(){
//               $(this).siblings('.itg_custom_popup').addClass('popup_open');
//               $('body').addClass('header_hide');
//           });
        
//           $(document).on('click', '.itg_close_popup', function(){
//               $('.itg_custom_popup').removeClass('popup_open');
//               $('body').removeClass('header_hide');
//           });
//         /*JS FOR PRODUCT PAGE POPUP START*/
//           $(document).on('click', '.itg_popup_click', function(){
//               $(this).siblings('.itg_custom_popup').addClass('popup_open');
//               $('body').addClass('header_hide');
//           });
        
//           $(document).on('click', '.itg_close_popup', function(){
//               $('.itg_custom_popup').removeClass('popup_open');
//               $('body').removeClass('header_hide');
//           });
//         /*JS FOR PRODUCT PAGE POPUP END*/

//         /*JS FOR PRODUCT PAGE VIDEO POPUP START*/
//           $('.itg_custom_video_wrapper img, .video_play_icon').click(function(){
//               $('.itg_video_popup').addClass('popup_open');
//               $('body').addClass('v_pop_open')
//           });
        
//           $('.itg_popup_close').click(function(){
//               $('.itg_video_popup').removeClass('popup_open');
//               $('body').removeClass('v_pop_open')
//               var video_url = $(this).closest('.itg_video_popup').find('iframe').attr('src');
//               $(this).closest('.itg_video_popup').find('iframe').attr('src', video_url);
//           });
//         /*JS FOR PRODUCT PAGE VIDEO POPUP END*/

//         // /*JS FOR PRODUCT SLIDER START*/
//            $('.template-product .custom-hidden-mobile').removeClass('custom-hidden-mobile');
//               $('.mobile-loader-image').hide();
//               var slideControls   = $(document).find('.slide-controls-product');
//            let mql = window.matchMedia("(min-width: 720px)");
//             if(mql.matches){
//                     $('.slider-for').slick({
//                             slidesToShow: 1,
//                             slidesToScroll: 1,
//                             arrows: true,
//                             prevArrow:'<button type="button" class="dddd slick-prev pull-left"><svg width="8" height="14" viewBox="0 0 8 14" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M7.25 13.5L0.75 7L7.25 0.5" stroke="#991B1E" stroke-width="0.83" stroke-linecap="round" stroke-linejoin="round"/></svg></button>',
//                             nextArrow:'<button type="button" class="dddd slick-next pull-right"><svg width="8" height="14" viewBox="0 0 8 14" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0.75 13.5L7.25 7L0.75 0.5" stroke="#991B1E" stroke-width="0.83" stroke-linecap="round" stroke-linejoin="round"/></svg></button>',
//                             fade: true,
//                             draggable: true,
//                             asNavFor: '.cstm_slider_nav',
//                             responsive: [
//                                 {
//                                   breakpoint: 767,
//                                   settings: {
//                                     arrows: true,
//                                     dots: true,
//                                     appendDots: slideControls,
//                                     dotsClass: 'custom-dots'
//                                   }
//                                 },
//                             ]
//                         });
                
            
        
//          $('.cstm_slider_nav').slick({
//                    slidesToShow: 6,
//                    slidesToScroll: 1,
//                    infinite: false,
//                    asNavFor: '.slider-for',
//                   dots: false,
//                   arrow: true,
//                   prevArrow: '<button type="button" class="slick-prev"><svg width="8" height="14" viewBox="0 0 8 14" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M7.25 13.5L0.75 7L7.25 0.5" stroke="#991B1E" stroke-width="0.83" stroke-linecap="round" stroke-linejoin="round"/></svg></button>',
//                   nextArrow: '<button type="button" class="slick-next"><svg width="8" height="14" viewBox="0 0 8 14" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0.75 13.5L7.25 7L0.75 0.5" stroke="#991B1E" stroke-width="0.83" stroke-linecap="round" stroke-linejoin="round"/></svg></button>',
//                   centerMode: false,
//                   focusOnSelect: true,
//                   vertical: true,
//                   verticalSwiping:true,
//                    draggable: true,
//                   responsive: [
//                       {
//                            breakpoint: 767,
//                           settings: {
//                               arrow: true,
//                                prevArrow: '<button type="button" class="slick-prev"><svg width="8" height="14" viewBox="0 0 8 14" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M7.25 13.5L0.75 7L7.25 0.5" stroke="#991B1E" stroke-width="0.83" stroke-linecap="round" stroke-linejoin="round"/></svg></button>',
//                               nextArrow: '<button type="button" class="slick-next"><svg width="8" height="14" viewBox="0 0 8 14" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0.75 13.5L7.25 7L0.75 0.5" stroke="#991B1E" stroke-width="0.83" stroke-linecap="round" stroke-linejoin="round"/></svg></button>',
//                                slidesToShow: 4,
//                               slidesToScroll: 1,
//                              swipeToSlide: true
//                            }
//                       },
//                      {
//                           breakpoint: 480,
//                           settings: {
//                              arrow: true,
//                               prevArrow: '<button type="button" class="slick-prev"><svg width="8" height="14" viewBox="0 0 8 14" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M7.25 13.5L0.75 7L7.25 0.5" stroke="#991B1E" stroke-width="0.83" stroke-linecap="round" stroke-linejoin="round"/></svg></button>',
//                             nextArrow: '<button type="button" class="slick-next"><svg width="8" height="14" viewBox="0 0 8 14" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0.75 13.5L7.25 7L0.75 0.5" stroke="#991B1E" stroke-width="0.83" stroke-linecap="round" stroke-linejoin="round"/></svg></button>',
//                               slidesToShow: 3,
//                               slidesToScroll: 1,
//                             centerMode: false,
//                          }
//                     }
//                  ]
//               });
//           }
//           if(!mql.matches){
//               $('.cstm_slider_nav').slick({
//                    slidesToShow: 6,
//                    slidesToScroll: 1,
//                    infinite: false,
//                   dots: false,
//                   arrow: true,
//                   prevArrow: '<button type="button" class="slick-prev"><svg width="8" height="14" viewBox="0 0 8 14" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M7.25 13.5L0.75 7L7.25 0.5" stroke="#991B1E" stroke-width="0.83" stroke-linecap="round" stroke-linejoin="round"/></svg></button>',
//                   nextArrow: '<button type="button" class="slick-next"><svg width="8" height="14" viewBox="0 0 8 14" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0.75 13.5L7.25 7L0.75 0.5" stroke="#991B1E" stroke-width="0.83" stroke-linecap="round" stroke-linejoin="round"/></svg></button>',
//                   centerMode: false,
//                   focusOnSelect: true,
//                   vertical: true,
//                   verticalSwiping:true,
//                    draggable: true,
//                   responsive: [
//                       {
//                            breakpoint: 767,
//                           settings: {
//                               arrow: true,
//                                prevArrow: '<button type="button" class="slick-prev"><svg width="8" height="14" viewBox="0 0 8 14" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M7.25 13.5L0.75 7L7.25 0.5" stroke="#991B1E" stroke-width="0.83" stroke-linecap="round" stroke-linejoin="round"/></svg></button>',
//                               nextArrow: '<button type="button" class="slick-next"><svg width="8" height="14" viewBox="0 0 8 14" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0.75 13.5L7.25 7L0.75 0.5" stroke="#991B1E" stroke-width="0.83" stroke-linecap="round" stroke-linejoin="round"/></svg></button>',
//                                slidesToShow: 4,
//                               slidesToScroll: 1,
//                              swipeToSlide: true
//                            }
//                       },
//                      {
//                           breakpoint: 480,
//                           settings: {
//                              arrow: true,
//                               prevArrow: '<button type="button" class="slick-prev"><svg width="8" height="14" viewBox="0 0 8 14" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M7.25 13.5L0.75 7L7.25 0.5" stroke="#991B1E" stroke-width="0.83" stroke-linecap="round" stroke-linejoin="round"/></svg></button>',
//                             nextArrow: '<button type="button" class="slick-next"><svg width="8" height="14" viewBox="0 0 8 14" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0.75 13.5L7.25 7L0.75 0.5" stroke="#991B1E" stroke-width="0.83" stroke-linecap="round" stroke-linejoin="round"/></svg></button>',
//                               slidesToShow: 3,
//                               slidesToScroll: 1,
//                             centerMode: false,
//                          }
//                     }
//                  ]
//               });
//           }

//         //       /*JS FOR PRODUTC SLIDER END*/

// //    $('.slider-for').slick({
// //     slidesToShow: 1,
// //     slidesToScroll: 1,
// //     arrows: false,
// //     fade: true,
// //     asNavFor: '.slider-nav'
// //   });
// //   $('.slider-nav').slick({
// //     slidesToShow: 4,
// //     slidesToScroll: 1,
// //     asNavFor: '.slider-for',
// //     dots: false,
// //     focusOnSelect: true,
// //     vertical: true,
// //     verticalSwiping:true,
// //     draggable: true
// //   });
  
// });

// // $(document).ready(function(){
// //     $('.utils-showby li').click(function(){
// //       $('li a').removeClass("utils-showby-item--active");
// //       $(this).addClass("utils-showby-item--active");
// //     });
// // });
//   $('.options-selection__option-value-input').click(function(){
//   var getdata =  $('.product-form--atc-button').html();
//     console.log(getdata)
//     var gettext = $('.product-form--atc-button .atc-button--text').text();
//     // console.log(gettext)
//     setTimeout(function () {
//     $('.product-form--atc-button').html(getdata);
//         }, 200)
//   })
// // $(window).on('click',function(event){
// //   var currTar = event.target.parentElement;
// //   console.log(currTar);
// // });

$(document).ready(function(){
  
    /*Wishlist Trigger click*/
        $(".wishlist-ctm-button").click(function(){
           $(this).toggleClass('added');
           $(".check-wish").find(".wishlist-engine").trigger('click');
        });
         $(window).on('load', function () {
              $(".wishlist-engine").each(function(){
                  var compr_wish = $(this).attr('data-added');
                  if(compr_wish == 'true'){
                   $(".wishlist-ctm-button").toggleClass('added');
                  }
              });
         });
   /*End Wishlist Trigger click*/     

   /*JS FOR CUSTOM POPU IN HOME PAGE START*/
   // $('.wrapper_popup, .overlay_popup').fadeIn("slow");
   //          $('.template-index').css("overflow","hidden");
   //          $('.cancle_icon svg, .overlay_popup').click(function(){
   //            $('.wrapper_popup, .overlay_popup').fadeOut("slow");
   //               $('.template-index').css("overflow","visible");
   //          });
   //            $('.wrapper_popup').find('label.form-field-title').text('Enter your email');
          /*JS FOR CUSTOM POPU IN HOME PAGE NED*/

        /*JS FOR HIDE/SHOW PRODUCT THUMBNAIL START*/
            $("button.slick-arrow").click(function(){
                $("button.slick-arrow").removeClass('hide-display');
                  $(this).addClass('hide-display');
              $('.pswp').hide();
            });
            $(".product-gallery--viewer.slider-for .slick-list.draggable").click(function(){
              $('.pswp').show();
              $('.product-zoom--thumb-scroller').hide();
            });
        /*JS HIDE/SHOW PRODUCT THUMBNAIL END*/
        
        /*JS FRO FILTER DRAWER START*/
             $('.filter_access').click(function(){
          $('.productgrid--sidebar').css("transform","translate(0)");
        });
         $('.close-icon-svg svg').click(function(){
            $('.productgrid--sidebar').css("transform","translate(-300px)");
         });
        /*JS FOR FILTER DRAWER END*/

        /*JS FOR WISHLIST START*/
          $(document).find(".wishlist-engine").click(function(){
              var ths_attr = $(this).attr('data-added');
              if(ths_attr == 'true'){
                $(this).closest('.itg_collection_wishlist').find('.itg_hover_content').html("Add to Wishlist");
              }else{
                 $(this).closest('.itg_collection_wishlist').find('.itg_hover_content').html("Remove from Wishlist");
              }
          });

          $(document).on('click', '.wishlist-page .wishlist-move-cart', function(){
              setTimeout(function () {
                  $.getJSON('/cart', function(cart){
                    console.log(cart)
                      $('.site-header-cart--count').attr('data-header-cart-count', cart.item_count)
                  })
              }, 500)
          })
          
          $(window).on('load', function () {
              $(".wishlist-engine").each(function(){
                  var ths_attr = $(this).attr('data-added');
                  if(ths_attr == 'true'){
                    $(this).closest('.itg_collection_wishlist').find('.itg_hover_content').html("Remove from Wishlist");
                  }else{
                     $(this).closest('.itg_collection_wishlist').find('.itg_hover_content').html("Add to Wishlist");
                  }
              });
          });
        /*JS FOR WISHLIST END*/
            $(document).on('click', '.itg_popup_click', function(){
              $(this).siblings('.itg_custom_popup').addClass('popup_open');
              $('body').addClass('header_hide');
          });
        
          $(document).on('click', '.itg_close_popup', function(){
              $('.itg_custom_popup').removeClass('popup_open');
              $('body').removeClass('header_hide');
          });
        /*JS FOR PRODUCT PAGE POPUP START*/
          $(document).on('click', '.itg_popup_click', function(){
              $(this).siblings('.itg_custom_popup').addClass('popup_open');
              $('body').addClass('header_hide');
          });
        
          $(document).on('click', '.itg_close_popup', function(){
              $('.itg_custom_popup').removeClass('popup_open');
              $('body').removeClass('header_hide');
          });
        /*JS FOR PRODUCT PAGE POPUP END*/

        /*JS FOR PRODUCT PAGE VIDEO POPUP START*/
          $('.itg_custom_video_wrapper img, .video_play_icon').click(function(){
              $('.itg_video_popup').addClass('popup_open');
              $('body').addClass('v_pop_open')
          });
        
          $('.itg_popup_close').click(function(){
              $('.itg_video_popup').removeClass('popup_open');
              $('body').removeClass('v_pop_open')
              var video_url = $(this).closest('.itg_video_popup').find('iframe').attr('src');
              $(this).closest('.itg_video_popup').find('iframe').attr('src', video_url);
          });
        /*JS FOR PRODUCT PAGE VIDEO POPUP END*/

        // /*JS FOR PRODUCT SLIDER START*/
        //    $('.template-product .custom-hidden-mobile').removeClass('custom-hidden-mobile');
        //       $('.mobile-loader-image').hide();
        //       var slideControls   = $(document).find('.slide-controls-product');
        //   $('.slider-for').slick({
        //           slidesToShow: 1,
        //           slidesToScroll: 1,
        //           arrows: true,
        //           prevArrow:'<button type="button" class="dddd slick-prev pull-left"><svg width="8" height="14" viewBox="0 0 8 14" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M7.25 13.5L0.75 7L7.25 0.5" stroke="#991B1E" stroke-width="0.83" stroke-linecap="round" stroke-linejoin="round"/></svg></button>',
        //           nextArrow:'<button type="button" class="dddd slick-next pull-right"><svg width="8" height="14" viewBox="0 0 8 14" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0.75 13.5L7.25 7L0.75 0.5" stroke="#991B1E" stroke-width="0.83" stroke-linecap="round" stroke-linejoin="round"/></svg></button>',
        //           fade: true,
        //           draggable: true,
        //           asNavFor: '.cstm_slider_nav',
        //           responsive: [
        //               {
        //                 breakpoint: 767,
        //                 settings: {
        //                   arrows: true,
        //                   dots: true,
        //                   appendDots: slideControls,
        //                   dotsClass: 'custom-dots'
        //                 }
        //               },
        //           ]
        //       });
      
     
        // $('.slider-nav').slick({
        //         slidesToShow: 6,
        //            slidesToScroll: 1,
        //          infinite: false,
        //           asNavFor: '.slider-for',
        //            dots: false,
        //           arrow: true,
        //            prevArrow: '<button type="button" class="slick-prev"><svg width="8" height="14" viewBox="0 0 8 14" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M7.25 13.5L0.75 7L7.25 0.5" stroke="#991B1E" stroke-width="0.83" stroke-linecap="round" stroke-linejoin="round"/></svg></button>',
        //           nextArrow: '<button type="button" class="slick-next"><svg width="8" height="14" viewBox="0 0 8 14" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0.75 13.5L7.25 7L0.75 0.5" stroke="#991B1E" stroke-width="0.83" stroke-linecap="round" stroke-linejoin="round"/></svg></button>',
        //           centerMode: false,
        //            focusOnSelect: true,
        //            vertical: true,
        //            verticalSwiping:true,
        //           draggable: true,
        //            responsive: [
        //              {
        //                    breakpoint: 767,
        //                   settings: {
        //                        arrow: true,
        //                       prevArrow: '<button type="button" class="slick-prev"><svg width="8" height="14" viewBox="0 0 8 14" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M7.25 13.5L0.75 7L7.25 0.5" stroke="#991B1E" stroke-width="0.83" stroke-linecap="round" stroke-linejoin="round"/></svg></button>',
        //                       nextArrow: '<button type="button" class="slick-next"><svg width="8" height="14" viewBox="0 0 8 14" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0.75 13.5L7.25 7L0.75 0.5" stroke="#991B1E" stroke-width="0.83" stroke-linecap="round" stroke-linejoin="round"/></svg></button>',
        //                       slidesToShow: 4,
        //                       slidesToScroll: 1,
        //                     swipeToSlide: true
        //                   }
        //               },
        //               {
        //                   breakpoint: 480,
        //                  settings: {
        //                       arrow: true,
        //                        prevArrow: '<button type="button" class="slick-prev"><svg width="8" height="14" viewBox="0 0 8 14" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M7.25 13.5L0.75 7L7.25 0.5" stroke="#991B1E" stroke-width="0.83" stroke-linecap="round" stroke-linejoin="round"/></svg></button>',
        //                        nextArrow: '<button type="button" class="slick-next"><svg width="8" height="14" viewBox="0 0 8 14" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0.75 13.5L7.25 7L0.75 0.5" stroke="#991B1E" stroke-width="0.83" stroke-linecap="round" stroke-linejoin="round"/></svg></button>',
        //                       slidesToShow: 3,
        //                         slidesToScroll: 1,
        //                      centerMode: false,
        //                   }
        //             }
        //          ]
        //       });

        //       /*JS FOR PRODUTC SLIDER END*/

//    $('.slider-for').slick({
//     slidesToShow: 1,
//     slidesToScroll: 1,
//     arrows: false,
//     fade: true,
//     asNavFor: '.slider-nav'
//   });
//   $('.slider-nav').slick({
//     slidesToShow: 4,
//     slidesToScroll: 1,
//     asNavFor: '.slider-for',
//     dots: false,
//     focusOnSelect: true
//     vertical: true,
//     verticalSwiping:true,
//     draggable: true
//   });
  
// });

// $(document).ready(function(){
//     $('.utils-showby li').click(function(){
//       $('li a').removeClass("utils-showby-item--active");
//       $(this).addClass("utils-showby-item--active");
//     });
// });

  /*
  $('.options-selection__option-value-input').click(function(){
  var getdata =  $('.product-form--atc-button').html();
    console.log(getdata)
    var gettext = $('.product-form--atc-button .atc-button--text').text();
    // console.log(gettext)
    setTimeout(function () {
    $('.product-form--atc-button').html(getdata);
        }, 200);
  });
  */
});   